import React, { useCallback, useEffect } from 'react';
import { RouteComponentProps } from 'react-router';
import { LinearProgress, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import useService from '../hooks/useService';
import { activate } from '../lib/services/devices';
import UPPage from '../components/UPPage';

/**
 * The page of the device activate
 * @param props
 */
export default function(
  props: RouteComponentProps<{ deviceId: string; token: string }>
) {
  const { t } = useTranslation('translation');
  const { isRequestDone, success, send } = useService(
    useCallback(
      () => activate(props.match.params.deviceId, props.match.params.token),
      [props.match.params]
    )
  );

  useEffect(() => {
    send();
  }, [send]);

  if (!isRequestDone) {
    return <LinearProgress color="primary" />;
  }

  if (!success) {
    return (
      <UPPage>
        <Typography variant="body1" color="error">
          {t('activateFailure')}
        </Typography>
      </UPPage>
    );
  }

  return (
    <UPPage>
      <Typography variant="body1">{t('activateSuccessfull')}</Typography>
      <Button href="/auth" fullWidth variant="contained" color="primary">
        {t('goToAuthorizationPage')}
      </Button>
    </UPPage>
  );
}
